import React from 'react'
import Hero2 from '../common/hero/Hero2';
import Footer from '../common/footer/Footer';
import Navbar from '../common/navbar/Navbar';
import ServicesComponent from './ServicesComponent';
const Services = () => {
  return (
    <div>
      <Navbar/>
      {/* <Hero2 heading="My Services" text="I provide all of these services"/> */}
      <ServicesComponent/>
      <Footer/>
    </div>
  )
}

export default Services;